module.exports = __webpack_public_path__ + "img/cut_sx1.23a95c08.png";